import { render } from "./AppAccordion.vue?vue&type=template&id=3091916a"
import script from "./AppAccordion.vue?vue&type=script&lang=js"
export * from "./AppAccordion.vue?vue&type=script&lang=js"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__